// グローバル変数
let allProductsData = [];
let isLoading = false;
// API config will be read inside initializePagination

// ページネーション設定
const paginationConfig = {
  itemsPerPage: 100, // デフォルトの1ページあたりの表示件数（5-250の範囲で設定可能）
  currentPage: {
    'all': 1,
    'shipping': 1,
    'takeout': 1
  }
};

// ホバー効果のためのスタイル
const style = document.createElement('style');
style.textContent = `
  .hover-image-container {
    position: relative;
    width: 100%;
    height: 100%;
  }
  .hover-image-primary,
  .hover-image-secondary {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: opacity 0.3s ease-in-out;
  }
  .hover-image-primary {
    opacity: 1;
  }
  .hover-image-secondary {
    opacity: 0;
  }
  .hover-image-container:hover .hover-image-primary {
    opacity: 0;
  }
  .hover-image-container:hover .hover-image-secondary {
    opacity: 1;
  }
`;
document.head.appendChild(style);

// --- Storefront API関連 ---

// GraphQLクエリ定義 (正しいコレクションベースのクエリに変更)
const OtoriyoseCollectionProductsQuery = `
  query OtoriyoseVendorProducts(
    $vendorQuery: String!   # 例: "vendor:'zopf'"
    $first: Int!
    $after: String
  ) {
    products(
      first: $first
      after: $after
      query: $vendorQuery        # 👈 ベンダーで絞り込み
      sortKey: BEST_SELLING      # 任意。不要なら消してね
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          title
          handle
          onlineStoreUrl
          vendor
          tags
          availableForSale
          compareAtPriceRange {
            minVariantPrice { amount currencyCode }
          }
          priceRange {
            minVariantPrice { amount currencyCode }
          }
          featuredImage {
            url(transform: { maxWidth: 533 })
            altText
            width
            height
          }
          images(first: 10) {
            edges {
              node {
                url(transform: { maxWidth: 533 })
                altText
                width
                height
              }
            }
          }
          takeoutFlag: metafield(namespace: "iku_fields", key: "takeout_flag") {
            value
            type
          }
          invoiceType: metafield(namespace: "iku_fields", key: "invoice_type") {
            value
            type
          }
          limitedAccessFlag: metafield(namespace: "iku_fields", key: "limited_access_product_flag") {
            value
            type
          }
          storeName: metafield(namespace: "iku_fields", key: "store_name") {
            value
            type
          }
        }
      }
    }
  }
`;

// fetchStorefrontAPI 関数は削除し、代わりに window.storefront を使用する

// 全商品データを取得する関数 (ページネーション対応, window.storefront を使用)
async function fetchAllProducts(handle) {
  let allProducts = [];
  let hasNextPage = true;
  let endCursor = null;
  const first = 250;

  console.log(`Fetching all products for handle: ${handle}...`);
  showLoadingOverlay(true);

  if (typeof window.storefront !== 'function') {
    console.error('window.storefront function is not available');
    showLoadingOverlay(false);
    return [];
  }

  try {
    while (hasNextPage) {
      const variables = {
        vendorQuery: `vendor:'${handle.replace(/'/g, "\\'")}'`,
        first: first,
        after: endCursor
      };

      console.log("Executing query with variables:", variables);

      const data = await window.storefront(OtoriyoseCollectionProductsQuery, variables);
      console.log("Storefront response:", data);

      if (!data || !data.products || !data.products.edges) {
        console.error('Invalid response structure:', data);
        break;
      }

      const newProducts = data.products.edges.map(edge => edge.node);
      allProducts = allProducts.concat(newProducts);
      
      hasNextPage = data.products.pageInfo.hasNextPage;
      endCursor = data.products.pageInfo.endCursor;

      console.log(`Fetched ${allProducts.length} products... More: ${hasNextPage}`);
      
      if (hasNextPage) {
        await new Promise(resolve => setTimeout(resolve, 500)); // Add delay between requests
      }
    }
  } catch (error) {
    console.error('Error fetching products:', error);
  }

  showLoadingOverlay(false);
  return allProducts;
}

// --- 商品カードHTML生成 ---

// 価格表示HTML (簡易版 - 必要なら price.liquid を参考に修正)
function renderPrice(product) {
  const price = parseFloat(product.priceRange.minVariantPrice.amount);
  const compareAtPrice = product.compareAtPriceRange?.minVariantPrice?.amount
    ? parseFloat(product.compareAtPriceRange.minVariantPrice.amount)
    : 0;
  const isSoldOut = product.availableForSale === false;
  const currentPriceColor = isSoldOut
    ? '#999999'
    : compareAtPrice > price
      ? '#FF4D4D'
      : '#333333';

  return `
    <div class="ik-product-price tw-mt-1 tw-flex tw-flex-wrap tw-items-center tw-gap-y-0 tw-justify-end tw-text-right">
      ${compareAtPrice > price ? `
        <span class="ik-product-price__compare tw-inline-flex tw-items-center tw-text-xs tw-font-normal tw-tracking-tight tw-line-through" style="color:#999999; font-weight:400; margin-right:4px;">
          ${formatCurrency(compareAtPrice)}
        </span>
      ` : ''}
      <span class="ik-product-price__current tw-inline-flex tw-items-center tw-text-base tw-font-bold tw-tracking-tight" style="color:${currentPriceColor};">
        ${formatCurrency(price)}
      </span>
    </div>
  `;
}

// 通貨フォーマット (簡易版)
function formatCurrency(amount) {
  // 必要に応じてロケールや通貨記号を考慮
  return `¥${Math.round(amount).toLocaleString()}`;
}

// 画像srcset生成 (簡易版 - card-product.liquid のロジックを参考に、settings.page_width 依存を削除)
function createImageSrcset(image, sizes = "(min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)") {
    if (!image?.url) return '';
    // Storefront APIの transform で取得したURLをそのまま使う
    // より正確なsrcsetが必要な場合は、`image.url` の transform パラメータを調整するか、
    // `image.originalSrc` を取得して手動生成します。
    // Liquidの image_url フィルタ相当の処理が必要になる場合があります。
    // ここでは取得したURL (maxWidth: 533) をベースとします。
    const baseUrl = image.url.replace(/_(\d+)x(\d+)?(_crop_\w+)?\.\w+$/, ''); // Remove existing size suffix if any
    const extension = image.url.split('.').pop().split('?')[0]; // Get file extension

    // 基本的なsrcsetを生成 (必要に応じて幅を追加)
    let srcset = '';
    const widths = [165, 360, 533, 720, 940, 1066]; // Common widths from card-product.liquid
    widths.forEach(w => {
        if (!image.width || image.width >= w) {
            srcset += `${baseUrl}_${w}x.${extension} ${w}w, `;
        }
    });
    srcset += `${image.url} ${image.width || 533}w`; // Add the transformed URL as fallback/specific size

    return `srcset="${srcset}" sizes="${sizes}"`;
}


// 商品カードHTMLを生成する関数 (テーマ設定への依存を削除)
function createProductCardHTML(product) {
  const settings = window.productCardSettings || {};
  const takeoutFlag = product.takeoutFlag?.value === 'true';
  const storeName = product.storeName?.value || product.vendor;
  const lazyLoad = settings.lazy_load !== false;

  const isFurusato = product.tags?.includes('furusato');
  const externalUrlText = isFurusato ? 'ふるさと納税サイトへ' : '';
  const hasNewTag = product.tags?.includes('new') || product.tags?.includes('New');
  const hasGiftableTag = product.tags?.includes('giftable');
  const hasFewLeftTag = product.tags?.includes('few-left');
  const hasSalesEndSoonTag = product.tags?.includes('sales-end-soon');
  const isSoldOut = product.availableForSale === false;
  const price = parseFloat(product.priceRange.minVariantPrice.amount);
  const compareAtPrice = product.compareAtPriceRange?.minVariantPrice?.amount
    ? parseFloat(product.compareAtPriceRange.minVariantPrice.amount)
    : 0;
  const showNewLabel = hasNewTag && !isSoldOut;
  const showSaleLabel = compareAtPrice > price && !isSoldOut;
  const showGiftableLabel = hasGiftableTag;
  const showFewLeftLabel = hasFewLeftTag;
  const showEndingSoonLabel = hasSalesEndSoonTag && !hasFewLeftTag;

  const featuredMedia = product.featuredImage;
  
  // 二枚目の画像を取得（2番目の画像を使用）
  let secondaryMedia = null;
  if (settings.show_secondary_image && product.images?.edges?.length > 1) {
    secondaryMedia = product.images.edges[1].node;
  }

  // デバッグ用ログ
  console.log('Product images:', {
    title: product.title,
    featuredImage: featuredMedia?.url,
    secondaryImage: secondaryMedia?.url,
    totalImages: product.images?.edges?.length,
    allImages: product.images?.edges?.map(edge => edge.node.url)
  });

  const iconShopOutlineSVG = `<svg viewBox="0 -960 960 960" fill="currentColor" aria-hidden="true" focusable="false">
<path d="M816-504v287.64q0 29.85-21.15 51.1Q773.7-144 744-144H216q-29.7 0-50.85-21.5Q144-187 144-216v-289q-33-23-41.5-59t.5-76l46-128q5-24 23-36t43.67-12h528.66q25.67 0 43.17 11t23.5 37l46 128q9 40 0 76t-41 60Zm-248-48q21 0 35.5-14t12.5-34l-24-144h-72v143.62Q520-580 534-566q14 14 34 14Zm-176.5 0q20.5 0 34.5-14t14-34.38V-744h-72l-24 144q-2 20 12.5 34t35 14ZM216-552q18 0 31.5-11t15.5-28l25-153h-72l-45 128q-8 23 6 43.5t39 20.5Zm528 0q25 0 39.5-20.5T790-616l-46-128h-72l25 153q2 17 16 28t31 11ZM216-216h528v-264q-25 0-47.5-9.5T656-519q-18 20-40.36 29.5T568-480q-25.18 0-47.09-10Q499-500 480-519q-17 19-40 29t-48 10q-25 0-47-8.5T304-519q-22.02 21.55-43.51 30.28Q239-480 216-480v264Zm528 0H216h.5-.71 528.28H743h1Z"/></svg>`;
  const iconGiftsOutlineSVG = `<svg viewBox="0 -960 960 960" fill="currentColor" aria-hidden="true" focusable="false">
<path d="M168-96v-432H96v-216h184q-5-11-7.5-22.94Q270-778.87 270-792q0-50 35-85t85-35q26.29 0 49.14 11Q462-890 480-871q17-19 40.5-30t49.5-11q50 0 85 35t35 85q0 12-3.5 24t-6.5 24h184v216h-72v432H168Zm368-730.2q-14 13.8-14 34.2 0 20.4 13.8 34.2Q549.6-744 570-744q20.4 0 34.2-13.8Q618-771.6 618-792q0-20.4-14-34.2-14-13.8-34-13.8t-34 13.8ZM342-792q0 20.4 14 34.2 14 13.8 34 13.8t34-13.8q14-13.8 14-34.2 0-20.4-13.8-34.2Q410.4-840 390-840q-20.4 0-34.2 13.8Q342-812.4 342-792ZM168-672v72h276v-72H168Zm276 504v-360H240v360h204Zm72 0h204v-360H516v360Zm276-432v-72H516v72h276Z"/></svg>`;

  if (!product) {
    console.error('Product data is missing');
    return '';
  }

  const imageLabels = [];
  if (isSoldOut) {
    imageLabels.push('<span class="product-label product-label--sold-out">売り切れ</span>');
  }
  if (showNewLabel) {
    imageLabels.push('<span class="product-label product-label--new">NEW</span>');
  }
  if (showSaleLabel) {
    imageLabels.push('<span class="product-label product-label--sale">SALE</span>');
  }
  if (takeoutFlag) {
    imageLabels.push(`
      <span class="product-label product-label--store-pickup">
        <span class="product-label__icon product-label__icon--desktop">${iconShopOutlineSVG}</span>
        <span>店頭受取</span>
      </span>
    `);
  }
  const imageLabelsHTML = imageLabels.length
    ? `<div class="product-label-set product-label-set--image">${imageLabels.join('')}</div>`
    : '';

  const titleLabels = [];
  if (showGiftableLabel) {
    titleLabels.push(`
      <span class="product-label product-label--giftable">
        <span class="product-label__icon product-label__icon--desktop">${iconGiftsOutlineSVG}</span>
        <span>ギフト可</span>
      </span>
    `);
  }
  if (showFewLeftLabel) {
    titleLabels.push('<span class="product-label product-label--few-left">残りわずか</span>');
  }
  if (showEndingSoonLabel) {
    titleLabels.push('<span class="product-label product-label--ending-soon">まもなく終了</span>');
  }
  const titleLabelsHTML = titleLabels.length
    ? `<div class="product-label-set product-label-set--title">${titleLabels.join('')}</div>`
    : '';

  return `
    <li class="grid__item">
      <div class="card-wrapper">
        <div class="card card--standard card--media" style="--ratio-percent: 100%;">
          <div class="card__inner ratio">
            <div class="card__media">
              <div class="media media--transparent media--hover-effect">
                <div class="tw-relative tw-aspect-square">
                  ${isFurusato ? `
                    <a href="#" target="_blank" rel="noopener" class="tw-block tw-relative tw-w-full tw-h-full ${secondaryMedia ? 'hover-image-container' : ''}">
                  ` : `
                    <a href="/products/${product.handle}" class="tw-block tw-relative tw-w-full tw-h-full ${secondaryMedia ? 'hover-image-container' : ''}">
                  `}
                  ${featuredMedia ? `
                    <img
                      src="${featuredMedia.url}"
                      alt="${featuredMedia.altText || product.title}"
                      loading="${lazyLoad ? 'lazy' : 'eager'}"
                      class="hover-image-primary"
                      width="533"
                      height="533"
                    >
                  ` : ''}
                  ${secondaryMedia ? `
                    <img
                      src="${secondaryMedia.url}"
                      alt="${product.title} | ${storeName || ''}"
                      loading="${lazyLoad ? 'lazy' : 'eager'}"
                      class="hover-image-secondary"
                      width="533"
                      height="533"
                    >
                  ` : ''}
                  </a>

                  ${imageLabelsHTML}
                </div>
              </div>
            </div>
          </div>

          <div class="card__content">
            <div class="card__information">
              ${titleLabelsHTML}
              <h3 class="card__heading">
                ${isFurusato ? `
                  <a href="#" target="_blank" rel="noopener" class="tw-text-[#333333] hover:tw-underline tw-font-bold tw-tracking-tight">
                    ${product.title}
                  </a>
                ` : `
                  <a href="/products/${product.handle}" class="tw-text-[#333333] hover:tw-underline tw-font-bold tw-tracking-tight">
                    ${product.title}
                  </a>
                `}
              </h3>

              ${settings.show_vendor ? `
                <div class="vendor tw-leading-none">
                  ${isFurusato ? `
                    <span class="visually-hidden">${settings.vendor_t || 'ベンダー'}</span>
                    <span class="tw-text-[#2E7D32] tw-text-sm tw-font-bold">${externalUrlText}</span>
                  ` : `
                    <span class="visually-hidden">${settings.vendor_t || 'ベンダー'}</span>
                    <a href="/collections/vendors?q=${encodeURIComponent(product.vendor)}" class="tw-text-[#BF9971] tw-text-sm tw-font-bold hover:tw-underline">${storeName}</a>
                  `}
                </div>
              ` : ''}

              <div class="card-information">
                ${renderPrice(product)}
              </div>
            </div>
          </div>

          <div class="card__badge">
            ${isFurusato ? `
              <a href="#" target="_blank" rel="noopener" class="full-unstyled-link"></a>
            ` : `
              <a href="/products/${product.handle}" class="full-unstyled-link"></a>
            `}
          </div>
        </div>
      </div>
    </li>
  `;
}


// --- ページネーションロジック ---

// URLから現在のページ番号を取得
function getCurrentPage() {
  const url = new URL(window.location.href);
  const pageParam = url.searchParams.get('p');
  return pageParam ? parseInt(pageParam, 10) : 1;
}

// URLから現在のタイプを取得
function getCurrentType() {
  const url = new URL(window.location.href);
  const typeParam = url.searchParams.get('type');
  // 有効なタイプか確認
  const validTypes = ['all', 'shipping', 'takeout'];
  return validTypes.includes(typeParam) ? typeParam : 'all';
}

// URLを更新 (ページリロードなし)
function updateURL(type, pageNumber) {
  const url = new URL(window.location.href);
  url.searchParams.set('type', type);
  url.searchParams.set('p', pageNumber);
  window.history.pushState({ type, page: pageNumber }, '', url.toString());
}

// グリッド設定を取得 (1ページあたりの商品数)
function getGridConfig(type) {
  const grid = document.querySelector(`#${type}-product-grid`);
  if (!grid) return null;
  return {
    perPageProducts: parseInt(grid.dataset.perPageProducts || '50', 10), // Liquidから渡された値
    gridElement: grid,
    containerElement: grid.closest('[id$="ProductsContainer"]'),
  };
}

// 商品データをフィルタリング
function filterProducts(type) {
  // ギフトオプション商品と限定公開商品を除外する基本フィルター
  const baseFilter = (product) => {
    const isGiftOptionProduct = product.tags?.includes('ギフト商品管理タグ');

    if (isGiftOptionProduct) {
      console.debug('Filtering out gift option product:', product.title);
      return false;
    }

    // 限定公開商品のチェック
    const isLimitedAccess = product.limitedAccessFlag?.value === 'true';
    
    // 限定公開商品を除外
    if (isLimitedAccess) {
      console.debug('Filtering out limited access product:', product.title);
      return false;
    }
    
    return true;
  };

  // タイプに応じたフィルタリング
  if (type === 'all') {
    return allProductsData.filter(baseFilter);
  } else if (type === 'shipping') {
    return allProductsData.filter(product => 
      baseFilter(product) && 
      product.takeoutFlag?.value !== 'true'
    );
  } else if (type === 'takeout') {
    return allProductsData.filter(product => 
      baseFilter(product) && 
      product.takeoutFlag?.value === 'true'
    );
  }
  return [];
}

// 商品件数表示を更新する関数を修正
function updateProductCounts() {
  const allProducts = filterProducts('all');
  const shippingProducts = filterProducts('shipping');
  const takeoutProducts = filterProducts('takeout');

  // デバッグ用にコンソールに出力
  console.log('商品件数の内訳:');
  console.log('全商品数:', allProducts.length);
  console.log('配送商品数:', shippingProducts.length);
  console.log('店頭受取商品数:', takeoutProducts.length);
  console.log('元データ総数:', allProductsData.length);

  // 各タブの件数表示を更新
  const containers = {
    'all': 'allProductsContainer',
    'shipping': 'shippingProductsContainer',
    'takeout': 'takeoutProductsContainer'
  };

  Object.entries(containers).forEach(([type, containerId]) => {
    const container = document.getElementById(containerId);
    if (container) {
      const countDisplay = container.querySelector('.pagination-info');
      if (countDisplay) {
        const count = type === 'all' ? allProducts.length :
                     type === 'shipping' ? shippingProducts.length :
                     takeoutProducts.length;
        countDisplay.textContent = `${count}件の商品`;
      }
    }
  });
}

// 指定ページの製品をレンダリング
function renderProductPage(type, pageNumber) {
  const config = getGridConfig(type);
  if (!config || !config.gridElement || !config.containerElement) return;

  const filteredProducts = filterProducts(type);
  const totalProducts = filteredProducts.length;
  
  // ページネーションの計算
  const itemsPerPage = paginationConfig.itemsPerPage;
  const totalPages = Math.ceil(totalProducts / itemsPerPage);
  const currentPage = Math.max(1, Math.min(pageNumber, totalPages || 1));
  
  // 現在のページの商品を取得
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const productsToShow = filteredProducts.slice(startIndex, endIndex);

  // グリッドをクリアして新しい商品を表示
  config.gridElement.innerHTML = '';
  
  if (productsToShow.length > 0) {
    productsToShow.forEach(product => {
      config.gridElement.innerHTML += createProductCardHTML(product);
    });
  } else if (!isLoading) {
    const emptyMessageContainer = config.containerElement.querySelector('.collection.page-width');
    if (emptyMessageContainer) {
      emptyMessageContainer.innerHTML = `
        <div class="collection collection--empty page-width">
          <div class="title-wrapper center">
            <h2 class="title title--primary">
              ${window.productCardSettings.products_empty_t}<br>
              ${window.productCardSettings.use_fewer_filters_html_t}
            </h2>
          </div>
        </div>`;
    }
  }

  // ページネーション情報の表示を更新
  updatePaginationInfo(type, {
    currentPage,
    totalPages,
    totalProducts,
    itemsPerPage,
    displayedProducts: productsToShow.length
  });

  // ページネーションボタンを更新
  updatePaginationButtons(type, currentPage, totalPages);
}

// ページネーションボタンを更新
function updatePaginationButtons(type, currentPage, totalPages) {
  const config = getGridConfig(type);
  if (!config || !config.containerElement) return;

  const paginationContainer = config.containerElement.querySelector('.pagination-container');
  if (!paginationContainer) return;

  paginationContainer.innerHTML = '';

  if (totalPages > 1) {
    // ページネーションボタンの生成
    const buttons = [];

    // 「前へ」ボタン
    if (currentPage > 1) {
      buttons.push(createPaginationButton(type, currentPage - 1, '前へ', 'prev'));
    }

    // ページ番号ボタン
    if (totalPages <= 7) {
      // 7ページ以下の場合はすべてのページを表示
      for (let i = 1; i <= totalPages; i++) {
        buttons.push(createPaginationButton(type, i, i.toString(), 'number', i === currentPage));
      }
    } else {
      // 7ページ以上の場合は省略形で表示
      buttons.push(createPaginationButton(type, 1, '1', 'number', currentPage === 1));
      
      if (currentPage > 3) {
        buttons.push(createEllipsis());
      }

      // 現在のページの前後のページを表示
      for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
        buttons.push(createPaginationButton(type, i, i.toString(), 'number', i === currentPage));
      }

      if (currentPage < totalPages - 2) {
        buttons.push(createEllipsis());
      }

      buttons.push(createPaginationButton(type, totalPages, totalPages.toString(), 'number', currentPage === totalPages));
    }

    // 「次へ」ボタン
    if (currentPage < totalPages) {
      buttons.push(createPaginationButton(type, currentPage + 1, '次へ', 'next'));
    }

    // ボタンをDOMに追加
    buttons.forEach(button => paginationContainer.appendChild(button));
  }
}

// ページネーションボタンを作成する関数
function createPaginationButton(type, page, text, buttonType, isActive = false) {
  const button = document.createElement('button');
  button.type = 'button';
  button.className = `
    tw-px-3 tw-py-2 tw-mx-1 tw-rounded-md tw-text-sm
    ${isActive 
      ? 'tw-bg-[#C39C73] tw-text-white' 
      : 'tw-bg-gray-100 tw-text-gray-700 hover:tw-bg-gray-200'}
    ${buttonType === 'prev' || buttonType === 'next' ? 'tw-px-4' : ''}
  `;
  button.textContent = text;
  
  button.onclick = () => {
    updatePageAndType(type, page);
    // スムーズスクロール
    const gridContainer = document.getElementById(`${type}ProductsContainer`);
    if (gridContainer) {
      gridContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return button;
}


// タイプとページを更新するメイン関数
function updatePageAndType(type, pageNumber) {
  if (isLoading) return; // ロード中は処理しない

  // URL更新
  updateURL(type, pageNumber);

  // コンテナ表示切り替え
  const containers = ['allProductsContainer', 'shippingProductsContainer', 'takeoutProductsContainer'];
  containers.forEach(containerId => {
    const container = document.getElementById(containerId);
    if (container) {
      container.classList.toggle('tw-hidden', containerId !== `${type}ProductsContainer`);
    }
  });

  // 商品表示更新
  renderProductPage(type, pageNumber);

  // タイプ切り替えボタンの更新 (もしあれば)
  if (typeof window.updateTypeButtons === 'function') {
    window.updateTypeButtons(type);
  }
}

// ローディングオーバーレイ表示切替
function showLoadingOverlay(show) {
    isLoading = show;
    const overlays = document.querySelectorAll('.loading-overlay');
    overlays.forEach(overlay => {
        overlay.style.display = show ? 'block' : 'none';
        // Optionally add/remove a class for more complex styling
        // overlay.classList.toggle('is-loading', show);
    });
}


// --- 初期化処理 ---

// ブラウザの戻る/進む操作に対応
window.addEventListener('popstate', (event) => {
  // popstate イベント発生時に isLoading をチェックしない方が良い場合がある
  // (ユーザー操作なので、ロード中でも状態を復元すべき)
  const type = event.state?.type || getCurrentType();
  const page = event.state?.page || getCurrentPage();
  // 状態復元時にデータがまだなければ取得から行う
  // Corrected: Check for collectionHandle existence before calling initializePagination
  const currentCollectionHandle = window.productCardSettings?.collection_handle;
  if (allProductsData.length === 0 && currentCollectionHandle) {
      initializePagination();
  } else {
      updatePageAndType(type, page);
  }
});

// 動的ページネーションの初期化関数 (DOMContentLoadedで呼ばれる)
async function initializePagination() {
  // /collections/vendors ページ以外は処理しない
  if (window.location.pathname !== '/collections/vendors') {
    console.log('Not on /collections/vendors. Skipping dynamic pagination.');
    showLoadingOverlay(false); // Make sure loading is hidden if skipped
    return;
  }

  // --- Read config inside the function ---
  const storefrontApiUrl = window.productCardSettings?.storefrontApiUrl;
  const storefrontAccessToken = window.productCardSettings?.storefrontAccessToken;
  // Use the collection handle set in the Liquid template
  const collectionHandle = window.productCardSettings?.collection_handle;
  // --- End reading config ---


  // Storefront API 情報がない場合は何もしない
  if (!storefrontApiUrl || !storefrontAccessToken || !collectionHandle) {
    console.error('Missing Storefront API config or collection handle in window.productCardSettings. Skipping dynamic pagination.');
    showLoadingOverlay(false);
    return;
  }

  // 既にデータ取得済み、またはロード中なら何もしない
  if (allProductsData.length > 0 || isLoading) {
      console.log('Already initialized or loading.');
      return;
  }

  // --- Call fetchAllProducts without API config args ---
  // Use the determined collectionHandle
  allProductsData = await fetchAllProducts(collectionHandle);

  // データ取得後に初期表示 (allProductsDataが取得できた場合のみ)
  if (allProductsData && allProductsData.length > 0) {
    const initialType = getCurrentType();
    const initialPage = getCurrentPage();
    updatePageAndType(initialType, initialPage);
  } else {
    console.log('No products fetched or fetch failed, skipping initial render.');
    // Optionally display an error message or the empty state here
    // For now, just ensure loading is hidden
    showLoadingOverlay(false);
    // Render empty state for the initial type
    const initialType = getCurrentType();
    renderProductPage(initialType, 1); // Render page 1 of the initial type (will show empty message)
  }
} // End of initializePagination function

// DOMContentLoaded で初期化を実行
document.addEventListener('DOMContentLoaded', initializePagination);

// ページネーション情報の表示を更新する関数
function updatePaginationInfo(type, info) {
  const container = document.getElementById(`${type}ProductsContainer`);
  if (!container) return;

  const infoElement = container.querySelector('.pagination-info');
  if (infoElement) {
    const startItem = ((info.currentPage - 1) * info.itemsPerPage) + 1;
    const endItem = Math.min(startItem + info.displayedProducts - 1, info.totalProducts);
    
    infoElement.innerHTML = `
      <div class="tw-flex tw-justify-between tw-items-center tw-mb-4">
        <span class="tw-text-sm tw-text-gray-600">
          ${info.totalProducts}件の商品
        </span>
        <span class="tw-text-sm tw-text-gray-600">
          ${startItem} - ${endItem}件を表示
        </span>
      </div>
    `;
  }
}

// 省略記号要素を作成する関数
function createEllipsis() {
  const span = document.createElement('span');
  span.className = 'tw-px-2 tw-py-3 tw-text-gray-500';
  span.textContent = '...';
  return span;
}

// ページネーションの表示件数を設定する関数
function setItemsPerPage(count) {
  paginationConfig.itemsPerPage = count;
  // 各タイプのページを1ページ目にリセット
  Object.keys(paginationConfig.currentPage).forEach(type => {
    paginationConfig.currentPage[type] = 1;
    updatePageAndType(type, 1);
  });
}
